import { render, staticRenderFns } from "./UserRolePermissions.vue?vue&type=template&id=21246eee&scoped=true&"
import script from "./UserRolePermissions.vue?vue&type=script&lang=js&"
export * from "./UserRolePermissions.vue?vue&type=script&lang=js&"
import style0 from "./UserRolePermissions.vue?vue&type=style&index=0&id=21246eee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21246eee",
  null
  
)

export default component.exports